// extracted by mini-css-extract-plugin
export default {"button":"Ffv0h","only":"kRnkV","link":"swkYU"};